<div class="icon-stack">
  <capra-icon
    class="icon mode-icon"
    [icon]="isAnalystStudio ? 'illo-ts-logo-emblem' : 'illo-mode-logo-emblem'"
  ></capra-icon>
  <capra-icon class="icon sheet-icon" icon="illo-gsheets-feature"></capra-icon>
</div>

<hr />
